import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../Redux/Actions/index";
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../../component/Toasts/Toasts";
import "../EmployeeDb.scss";
import moment from "moment";
import { Dropdown, Button, InputGroup, Spinner } from "react-bootstrap";
import Select from "react-select";
import "./style.scss";
import {
  Strings,
  addEmployeeValidations,
  addEmployeeLabels,
} from "../../../constant/Strings/index";
import {
  employeeCandidateNameValidtion,
  employeeDesignationValidtion,
  employeeEmailIdValidation,
  employeeEmployeeIdValidtion,
  employeeLastNameValidtion,
  employeeMobileNumberValidtion,
  containsInvalidChars,
} from "../../../constant/Validations";
import { BsCheckLg, BsXLg, BsGear } from "react-icons/bs"; // Add Icons
import DepartmentManagerModal from "../../../component/ModalComponent/DepartmentManagerModal"
import ClientManagerModal from "../../../component/ModalComponent/ClientManagerModal";
const AddEmployee = (props: any) => {
  const { hideAddModal, totalEntries, apiCallCompleted, onEmployeeCreated } = props;
  const [btnDisable, setBtnDisable] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [employeeDetails, setEmployeeDetails] = useState({
    candidateName: "",
    middleName: "",
    lastname: "",
    dateOfBirth: "",
    gender: "",
    personalMail: "",
    emailId: "",
    mobileNumber: "",
    company: "",
    designation: "",
    dateOfJoining: "",
    employeeId: "",
    title: "",
    managerRef: "",
    reportingManagerName: "",
    clientName: "",
    businessUnit: "",
    department: "",
    subDepartment: "",
    financeCode: "",
    projectClassification: "",
    projectType: "",
    location: "",
    modeofWork: "",
    buHead: "",
    buHeadRef: "",
    hrbp: "",
    hrbpRef: "",
    departmentRef: "",
    subDepartmentRef: "",
    clientRef: "",
  });

  const [errors, setErrors] = useState({
    candidateName: "",
    middleName: "",
    lastname: "",
    emailId: "",
    mobileNumber: "",
    employeeId: "",
    designation: "",
    clientName: "",
    businessUnit: "",
    department: "",
    subDepartment: "",
    financeCode: "",
    projectClassification: "",
    projectType: "",
    location: "",
    modeofWork: "",
    buHead: "",
    hrbp: "",
  });
  const { addSuccess, cancel, submit, skillmineMailid, invalidCharsError, } = Strings;
  const {
    designationValid,
    mobileNumberValid,
    emailIdValid,
    employeeIdValid,
    lastnameValid,
    candidateNameValid,
  } = addEmployeeValidations;
  const {
    firstName,
    title,
    middleName,
    lastName,
    dateOfBirth,
    personalEmail,
    Ecode,
    officialEmail,
    mobileNumber,
    designation,
    dateOfJoining,
    reportingManagerName,
    clientNameLabel,
    businessUnit,
    department,
    subDepartment,
    financeCode,
    projectClassification,
    projectType,
    location,
    modeofWork,
    buHead,
  } = addEmployeeLabels;

  const dispatch = useDispatch();
  const isHrAdmin = (localStorage.getItem("role") || "").includes("hr-admin");

  const [employeeInfo, setEmployeeInfo] = useState([]);
  const employeeManagerData = useSelector(
    (state: any) => state.employeeReducer.getEmployeeData
  );
  useEffect(() => {
    if (employeeManagerData && employeeManagerData.data) {
      setEmployeeInfo(employeeManagerData.data);
    }
  }, [employeeManagerData, employeeInfo]);

  const managerOptions: any = employeeInfo.map((ele: any) => ({
    value: ele._id,
    label: ele.middleName
      ? ele.candidateName +
      " " +
      ele.middleName +
      " " +
      ele.lastname +
      "-" +
      ele.employeeId
      : ele.candidateName + " " + ele.lastname + "-" + ele.employeeId,
  }));
  const handleReportingManager = (selected: any) => {
    setEmployeeDetails({
      ...employeeDetails,
      managerRef: selected.value,
      reportingManagerName: selected.label,
    });
  };
  const handleBuHeadChange = (selected: any) => {
    setEmployeeDetails({
      ...employeeDetails,
      buHead: selected ? selected.label : "",
      buHeadRef: selected ? selected.value : ""
    });
    if (selected) setErrors(prev => ({ ...prev, buHead: "" }));
  };
  const handleHrbpChange = (selected: any) => {
    setEmployeeDetails({
      ...employeeDetails,
      hrbp: selected ? selected.label : "",
      hrbpRef: selected ? selected.value : ""
    });
    if (selected) setErrors(prev => ({ ...prev, hrbp: "" }));
  };

  useEffect(() => {
    if (
      employeeDetails.candidateName &&
      employeeDetails.lastname &&
      employeeDetails.dateOfBirth &&
      employeeDetails.employeeId &&
      employeeDetails.emailId &&
      employeeDetails.mobileNumber &&
      employeeDetails.designation &&
      employeeDetails.dateOfJoining &&
      employeeDetails.title &&
      employeeDetails.managerRef &&
      employeeDetails.clientName &&
      employeeDetails.businessUnit &&
      employeeDetails.department &&
      employeeDetails.subDepartment &&
      employeeDetails.financeCode &&
      employeeDetails.projectClassification &&
      employeeDetails.projectType &&
      employeeDetails.location &&
      employeeDetails.modeofWork &&
      employeeDetails.buHead
    ) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
  }, [employeeDetails]);

  let valid: boolean = true;
  const validate = () => {
    if (containsInvalidChars(employeeDetails.designation)) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        designation: invalidCharsError,
      }));
      setBtnDisable(false);
    } else if (employeeDesignationValidtion(employeeDetails.designation) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        designation: designationValid,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, designation: "" }));
    }
    if (employeeMobileNumberValidtion(employeeDetails.mobileNumber) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        mobileNumber: mobileNumberValid,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, mobileNumber: "" }));
    }
    if (
      employeeEmailIdValidation(employeeDetails.emailId) &&
      employeeDetails.emailId.includes(skillmineMailid)
    ) {
      setErrors((errorObj) => ({ ...errorObj, emailId: "" }));
    } else {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        emailId: emailIdValid,
      }));
      setBtnDisable(false);
    }

    if (
      employeeDetails.employeeId.length < 5 ||
      employeeDetails.employeeId.length > 9 ||
      employeeEmployeeIdValidtion(employeeDetails.employeeId) == false
    ) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        employeeId: employeeIdValid,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, employeeId: "" }));
    }
    if (containsInvalidChars(employeeDetails.lastname)) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        lastname: invalidCharsError,
      }));
      setBtnDisable(false);
    } else if (employeeLastNameValidtion(employeeDetails.lastname) == false) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        lastname: lastnameValid,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, lastname: "" }));
    }
    if (employeeDetails.middleName) {
      if (containsInvalidChars(employeeDetails.middleName)) {
        valid = false;
        setErrors((errorObj) => ({
          ...errorObj,
          middleName: invalidCharsError,
        }));
        setBtnDisable(false);
      } else if (employeeCandidateNameValidtion(employeeDetails.middleName) == false) {
        valid = false;
        setErrors((errorObj) => ({
          ...errorObj,
          middleName: candidateNameValid,
        }));
        setBtnDisable(false);
      } else {
        setErrors((errorObj) => ({ ...errorObj, middleName: "" }));
      }
    }
    if (containsInvalidChars(employeeDetails.candidateName)) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        candidateName: invalidCharsError,
      }));
      setBtnDisable(false);
    } else if (
      employeeCandidateNameValidtion(employeeDetails.candidateName) == false
    ) {
      valid = false;
      setErrors((errorObj) => ({
        ...errorObj,
        candidateName: candidateNameValid,
      }));
      setBtnDisable(false);
    } else {
      setErrors((errorObj) => ({ ...errorObj, candidateName: "" }));
    }
    if (containsInvalidChars(employeeDetails.clientName)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, clientName: invalidCharsError }));
    } else if (!employeeDetails.clientName?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, clientName: "Client Name is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, clientName: "" }));
    }
    if (containsInvalidChars(employeeDetails.businessUnit)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, businessUnit: invalidCharsError }));
    } else if (!employeeDetails.businessUnit?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, businessUnit: "Business Unit is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, businessUnit: "" }));
    }

    if (containsInvalidChars(employeeDetails.department)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, department: invalidCharsError }));
    } else if (!employeeDetails.department?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, department: "Department is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, department: "" }));
    }
    if (containsInvalidChars(employeeDetails.subDepartment)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, subDepartment: invalidCharsError }));
    } else if (!employeeDetails.subDepartment?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, subDepartment: "Sub Department is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, subDepartment: "" }));
    }
    if (containsInvalidChars(employeeDetails.financeCode)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, financeCode: invalidCharsError }));
    } else if (!employeeDetails.financeCode?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, financeCode: "Finance Code is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, financeCode: "" }));
    }
    if (containsInvalidChars(employeeDetails.projectClassification)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, projectClassification: invalidCharsError }));
    } else if (!employeeDetails.projectClassification?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, projectClassification: "Project Classification is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, projectClassification: "" }));
    }
    if (containsInvalidChars(employeeDetails.projectType)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, projectType: invalidCharsError }));
    } else if (!employeeDetails.projectType?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, projectType: "Project Type is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, projectType: "" }));
    }
    if (containsInvalidChars(employeeDetails.location)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, location: invalidCharsError }));
    } else if (!employeeDetails.location?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, location: "Location is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, location: "" }));
    }

    if (containsInvalidChars(employeeDetails.modeofWork)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, modeofWork: invalidCharsError }));
    } else if (!employeeDetails.modeofWork?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, modeofWork: "Mode of Work is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, modeofWork: "" }));
    }
    if (containsInvalidChars(employeeDetails.buHead)) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, buHead: invalidCharsError }));
    } else if (!employeeDetails.buHead?.trim()) {
      valid = false;
      setErrors((errorObj) => ({ ...errorObj, buHead: "BU Head is required" }));
    } else {
      setErrors((errorObj) => ({ ...errorObj, buHead: "" }));
    }
    // if (!employeeDetails.hrbpRef) { 
    //   valid = false;
    //   setErrors((errorObj) => ({ ...errorObj, hrbp: "HRBP is required" }));
    // } else {
    //   setErrors((errorObj) => ({ ...errorObj, hrbp: "" }));
    // }
  };
  const handleEmployeeSubmit = () => {
    validate();
    if (valid) {
      handleDispatch();
    }
  };
  const handleDispatch = () => {
    setIsSubmitting(true);
    apiCallCompleted(false);
    dispatch(
      actions.addEmployeeDataAction(employeeDetails, (res: any) => {
        if (res?.error?.error_description) {
          showErrorToastMessage(res?.error?.error_description);
          apiCallCompleted(true);
          setIsSubmitting(false);
        } else if (res?.code === 200) {
          showSuccessToastMessage(addSuccess);
          apiCallCompleted(true);
          setIsSubmitting(false);
          hideAddModal();
          const created = res?.data;
          if (created?._id && created?.personalMail && onEmployeeCreated) {
            onEmployeeCreated({
              employeeId: created._id,
              personalMail: created.personalMail,
              hrbpRef: created.hrbpRef,
              managerRef: created.managerRef,
            });
          }
        }
      })
    );
  };
  // --- DEPARTMENT LOGIC STATES ---
  const [deptOptions, setDeptOptions] = useState<any[]>([]);
  const [isAddingDept, setIsAddingDept] = useState(false);
  const [newDeptName, setNewDeptName] = useState("");
  const [isSubmittingDept, setIsSubmittingDept] = useState(false);
  const [showDeptManager, setShowDeptManager] = useState(false);

  // --- SUB-DEPARTMENT LOGIC STATES ---
  const [subDeptOptions, setSubDeptOptions] = useState<any[]>([]);
  const [isAddingSubDept, setIsAddingSubDept] = useState(false);
  const [newSubDeptName, setNewSubDeptName] = useState("");
  const [isSubmittingSubDept, setIsSubmittingSubDept] = useState(false);
  const [showSubDeptManager, setShowSubDeptManager] = useState(false);

  // Load Departments on Mount
  useEffect(() => {
    dispatch(actions.getAllDepartmentsAction((res: any) => {
      if (res?.data) setDeptOptions(res.data);
    }));
  }, [dispatch]);

  // Load Sub-Departments when Department Changes
  useEffect(() => {
    if (employeeDetails.department && deptOptions.length > 0) {
      const selectedDept = deptOptions.find(d => d.departmentName === employeeDetails.department);

      if (selectedDept) {
        dispatch(actions.getSubDepartmentsByParentAction(selectedDept._id, (res: any) => {
          if (res?.data) setSubDeptOptions(res.data);
        }));
      } else {
        setSubDeptOptions([]);
      }
    } else {
      setSubDeptOptions([]);
    }
  }, [employeeDetails.department, deptOptions, dispatch]);
  const handleAddNewDept = () => {
    if (!newDeptName.trim()) return;

    // VAPT CHECK
    if (containsInvalidChars(newDeptName)) {
      showErrorToastMessage(invalidCharsError);
      return;
    }

    setIsSubmittingDept(true);
    dispatch(actions.createDepartmentAction({ departmentName: newDeptName }, (res: any) => {
      setIsSubmittingDept(false);
      if (res?.data) {
        // 1. Update List
        setDeptOptions([...deptOptions, res.data]);
        // 2. Select it
        setEmployeeDetails({ ...employeeDetails, department: res.data.departmentName, departmentRef: res.data._id });
        setIsAddingDept(false);
        setNewDeptName("");
      } else {
        const errorMsg = res?.error?.response?.data?.error?.error_description || "Failed to add department";
        showErrorToastMessage(errorMsg);
      }
    }));
  };

  const handleAddNewSubDept = () => {
    if (!newSubDeptName.trim()) return;

    // VAPT CHECK
    if (containsInvalidChars(newSubDeptName)) {
      showErrorToastMessage(invalidCharsError);
      return;
    }

    // Find Parent ID
    const parentDept = deptOptions.find(d => d.departmentName === employeeDetails.department);
    if (!parentDept) {
      showErrorToastMessage("Please select a valid Department first.");
      return;
    }

    setIsSubmittingSubDept(true);
    dispatch(actions.createSubDepartmentAction({
      subDepartmentName: newSubDeptName,
      departmentRef: parentDept._id
    }, (res: any) => {
      setIsSubmittingSubDept(false);
      if (res?.data) {
        setSubDeptOptions([...subDeptOptions, res.data]);
        setEmployeeDetails({ ...employeeDetails, subDepartment: res.data.subDepartmentName, subDepartmentRef: res.data._id });
        setIsAddingSubDept(false);
        setNewSubDeptName("");
      } else {
        const errorMsg = res?.error?.response?.data?.error?.error_description || "Failed to add sub-department";
        showErrorToastMessage(errorMsg);
      }
    }));
  };
  const [clientOptions, setClientOptions] = useState<any[]>([]);
  const [isAddingClient, setIsAddingClient] = useState(false);
  const [newClientName, setNewClientName] = useState("");
  const [isSubmittingClient, setIsSubmittingClient] = useState(false);
  const [showClientManager, setShowClientManager] = useState(false);

  const clientDataRedux = useSelector((state: any) => state.employeeReducer.getClientNameDetails);

  useEffect(() => {
    dispatch(actions.getClientNameAction());
  }, [dispatch]);

  useEffect(() => {
    if (clientDataRedux && clientDataRedux.data) {
      setClientOptions(clientDataRedux.data);
    }
  }, [clientDataRedux]);
  const handleAddNewClient = () => {
    if (!newClientName.trim()) return;

    if (containsInvalidChars(newClientName)) {
      showErrorToastMessage(invalidCharsError);
      return;
    }

    setIsSubmittingClient(true);

    dispatch(actions.addClientNameAction({ clientName: newClientName }, (res: any) => {
      setIsSubmittingClient(false);

      if (res?.data || res?.code === 200) {
        const addedClient = res?.data || { clientName: newClientName };
        setClientOptions(prev => [...prev, addedClient]);
        setEmployeeDetails(prev => ({
          ...prev,
          clientName: addedClient.clientName,
          clientRef: res.data._id
        }));

        dispatch(actions.getClientNameAction());
        setIsAddingClient(false);
        setNewClientName("");

      } else {
        showErrorToastMessage(res?.error?.error_description || "Failed to add client");
      }
    }) as any);
  };
  useEffect(() => {
    if (employeeDetails.department && deptOptions.length > 0) {
      const exists = deptOptions.some(d => d.departmentName === employeeDetails.department);
      if (!exists) {
        setEmployeeDetails(prev => ({
          ...prev,
          department: "",       // Clear Department
          subDepartment: ""     // Clear Sub-Dept too (since parent is gone)
        }));
      }
    }
  }, [deptOptions, employeeDetails.department]);

  useEffect(() => {
    if (employeeDetails.subDepartment && subDeptOptions.length > 0) {
      const exists = subDeptOptions.some(d => d.subDepartmentName === employeeDetails.subDepartment);
      if (!exists) {
        setEmployeeDetails(prev => ({
          ...prev,
          subDepartment: "" // Clear Sub-Department
        }));
      }
    }
    else if (employeeDetails.subDepartment && subDeptOptions.length === 0) {
      setEmployeeDetails(prev => ({ ...prev, subDepartment: "" }));
    }
  }, [subDeptOptions, employeeDetails.subDepartment]);
  useEffect(() => {
    if (employeeDetails.clientName && clientOptions.length > 0) {
      const exists = clientOptions.some(c => c.clientName === employeeDetails.clientName);
      if (!exists) {
        setEmployeeDetails(prev => ({ ...prev, clientName: "", clientRef: "" }));
      }
    }
  }, [clientOptions, employeeDetails.clientName]);

  const [setDropdown, setShowDropdown] = useState(false);
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-4">
          <label className="form-label">
            {title}
            <span className="required">*</span>
          </label>
          <Dropdown
            onMouseLeave={() => setShowDropdown(false)}
            onMouseOver={() => setShowDropdown(true)}
            onSelect={(eventKey: any) =>
              setEmployeeDetails({
                ...employeeDetails,
                title: eventKey,
              })
            }
          >
            <Dropdown.Toggle variant="light" className="form-control">
              {employeeDetails.title}
            </Dropdown.Toggle>
            <Dropdown.Menu show={setDropdown}>
              <Dropdown.Item eventKey="Dr.">Dr.</Dropdown.Item>
              <Dropdown.Item eventKey="Miss">Miss</Dropdown.Item>
              <Dropdown.Item eventKey="Mr.">Mr.</Dropdown.Item>
              <Dropdown.Item eventKey="Ms.">Ms.</Dropdown.Item>
              <Dropdown.Item eventKey="Mrs.">Mrs.</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-4">
          <label className="form-label">
            {firstName}
            <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            value={employeeDetails.candidateName}
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                candidateName: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
          <p className="error">{errors.candidateName}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">{middleName}</label>
          <input
            type="text"
            className="form-control"
            value={employeeDetails.middleName}
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                middleName: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
          <p className="error">{errors.middleName}</p>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-4">
          <label className="form-label">
            {lastName}
            <span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            value={employeeDetails.lastname}
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                lastname: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
          <p className="error">{errors.lastname}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">{dateOfBirth}</label>
          <span className="required">*</span>
          <input
            type="date"
            max={moment().subtract(21, "year").format("YYYY-MM-DD")}
            value={employeeDetails.dateOfBirth}
            className="form-control"
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                dateOfBirth: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
        </div>
        <div className="col-md-4">
          <label className="form-label">Gender</label>
          <select
            className="form-control"
            value={employeeDetails.gender}
            onChange={(e) =>
              setEmployeeDetails({ ...employeeDetails, gender: e.target.value })
            }
          >
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>

      </div>

      <div className="row mt-3">
        <div className="col-md-4">
          <label className="form-label">{personalEmail}</label>
          <input
            type="email"
            className="form-control"
            value={employeeDetails.personalMail}
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                personalMail: e.target.value?.toLocaleLowerCase(),
              })
            }
          />
        </div>
        <div className="col-md-4">
          <label className="form-label">{Ecode}</label>
          <span className="required">*</span>
          <input
            type="text"
            maxLength={9}
            value={employeeDetails.employeeId}
            className="form-control"
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                employeeId: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
          <p className="error">{errors.employeeId}</p>
        </div>
        <div className="col-md-4">
          <label className="form-label">{officialEmail}</label>
          <span className="required">*</span>
          <input
            type="email"
            className="form-control"
            value={employeeDetails.emailId}
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                emailId: e.target.value?.toLocaleLowerCase(),
              })
            }
          />
          <p className="error">{errors.emailId}</p>
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">{mobileNumber}</label>
          <span className="required">*</span>

          <input
            type="text"
            maxLength={15}
            value={employeeDetails.mobileNumber}
            className="form-control"
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                mobileNumber: e.target.value.replace(/^\s+/, ""),
              })
            }
          />

          <p className="error">{errors.mobileNumber}</p>
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">{designation}</label>
          <span className="required">*</span>
          <input
            type="text"
            value={employeeDetails.designation}
            className="form-control"
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                designation: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
          <p className="error">{errors.designation}</p>
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">{dateOfJoining}</label>
          <span className="required">*</span>
          <input
            type="date"
            max={moment().format("YYYY-MM-DD")}
            value={employeeDetails.dateOfJoining}
            className="form-control"
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                dateOfJoining: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">{clientNameLabel}<span className="required">*</span></label>

          {isAddingClient ? (
            <InputGroup className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Enter new client name"
                value={newClientName}
                onChange={(e) => setNewClientName(e.target.value)}
                autoFocus
              />
              <Button variant="primary" onClick={handleAddNewClient} disabled={isSubmittingClient}>
                {isSubmittingClient ? <Spinner size="sm" animation="border" /> : <BsCheckLg />}
              </Button>
              <Button variant="outline-secondary" onClick={() => setIsAddingClient(false)}>
                <BsXLg />
              </Button>
            </InputGroup>
          ) : (
            <Select
              className="dropdown-select"
              isSearchable={true}
              placeholder="Select..."
              value={employeeDetails.clientName ? { value: employeeDetails.clientRef, label: employeeDetails.clientName } : null}
              options={clientOptions.map((c: any) => ({ value: c._id, label: c.clientName }))}
              noOptionsMessage={() => "No clients found"}
              onChange={(selected: any) => {
                if (!selected) return;
                setEmployeeDetails({
                  ...employeeDetails,
                  clientName: selected.label,
                  clientRef: selected.value
                });
              }}
              styles={{
                control: (base: any) => ({
                  ...base,
                  borderColor: errors.clientName ? '#dc3545' : base.borderColor,
                  minHeight: '38px',
                })
              }}
            />
          )}
          <p className="error">{errors.clientName}</p>
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">{reportingManagerName}</label>
          <span className="required">*</span>
          <Select
            className="dropdown-select"
            options={managerOptions}
            isSearchable={true}
            onChange={handleReportingManager}
          />
        </div>
        {/* <div className="row mt-3"> */}

         <div className="col-md-4 mt-3">
          <label className="form-label">{buHead}</label>
          <span className="required">*</span>
          <Select
            className="dropdown-select"
            options={managerOptions}
            isSearchable={true}
            onChange={handleBuHeadChange}
            placeholder="Select BU Head..."
            isClearable={true}
          />
          <p className="error">{errors.buHead}</p>
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">HR Business Partner (HRBP)</label>
          <Select
            className="dropdown-select"
            options={managerOptions}
            isSearchable={true}
            onChange={handleHrbpChange}
            placeholder="Select HRBP..."
            isClearable={true}
          />
          <p className="error">{errors.hrbp}</p>
        </div>

        <div className="col-md-4 mt-3">
          <label className="form-label">{businessUnit}</label>
          <span className="required">*</span>
          <input
            type="text"
            value={employeeDetails.businessUnit}
            className={`form-control ${errors.businessUnit ? 'is-invalid' : ''}`}
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                businessUnit: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
          <p className="error">{errors.businessUnit}</p>
        </div>

        <div className="col-md-4 mt-3">
          <label className="form-label">{department}<span className="required">*</span></label>

          {isAddingDept ? (
            <InputGroup className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Enter new department"
                value={newDeptName}
                onChange={(e) => setNewDeptName(e.target.value)}
                autoFocus
              />
              <Button variant="primary" onClick={handleAddNewDept} disabled={isSubmittingDept}>
                {isSubmittingDept ? <Spinner size="sm" animation="border" /> : <BsCheckLg />}
              </Button>
              <Button variant="outline-secondary" onClick={() => setIsAddingDept(false)}>
                <BsXLg />
              </Button>
            </InputGroup>
          ) : (
            <Select
              className="dropdown-select"
              isSearchable={true}
              placeholder="Select..."
              value={employeeDetails.department ? { value: employeeDetails.departmentRef, label: employeeDetails.department } : null}
              options={[
                ...(isHrAdmin ? [
                  { value: '__ADD__', label: '+ Add New Department' },
                  { value: '__MANAGE__', label: '⚙ Manage Departments' },
                ] : []),
                ...deptOptions.map((d: any) => ({ value: d._id, label: d.departmentName }))
              ]}
              onChange={(selected: any) => {
                if (!selected) return;
                if (selected.value === '__ADD__') { setIsAddingDept(true); return; }
                if (selected.value === '__MANAGE__') { setShowDeptManager(true); return; }
                setEmployeeDetails({
                  ...employeeDetails,
                  department: selected.label,
                  departmentRef: selected.value,
                  subDepartment: "",
                  subDepartmentRef: ""
                });
                setSubDeptOptions([]);
              }}
              formatOptionLabel={(opt: any) => {
                if (opt.value === '__ADD__') return <span style={{ color: '#0d6efd', fontWeight: 'bold' }}>{opt.label}</span>;
                if (opt.value === '__MANAGE__') return <span style={{ color: '#6c757d' }}>{opt.label}</span>;
                return <span>{opt.label}</span>;
              }}
              styles={{
                control: (base: any) => ({
                  ...base,
                  borderColor: errors.department ? '#dc3545' : base.borderColor,
                  minHeight: '38px',
                })
              }}
            />
          )}
          <p className="error">{errors.department}</p>
        </div>

        <div className="col-md-4 mt-3">
          <label className="form-label">{subDepartment}<span className="required">*</span></label>

          {isAddingSubDept ? (
            <InputGroup className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Enter new sub-department"
                value={newSubDeptName}
                onChange={(e) => setNewSubDeptName(e.target.value)}
                autoFocus
              />
              <Button variant="primary" onClick={handleAddNewSubDept} disabled={isSubmittingSubDept}>
                {isSubmittingSubDept ? <Spinner size="sm" animation="border" /> : <BsCheckLg />}
              </Button>
              <Button variant="outline-secondary" onClick={() => setIsAddingSubDept(false)}>
                <BsXLg />
              </Button>
            </InputGroup>
          ) : (
            <Select
              className="dropdown-select"
              isSearchable={true}
              placeholder="Select..."
              isDisabled={!employeeDetails.department}
              value={employeeDetails.subDepartment ? { value: employeeDetails.subDepartmentRef, label: employeeDetails.subDepartment } : null}
              options={[
                ...(isHrAdmin ? [
                  { value: '__ADD__', label: '+ Add New Sub-Dept' },
                  { value: '__MANAGE__', label: '⚙ Manage Sub-Depts' },
                ] : []),
                ...subDeptOptions.map((d: any) => ({ value: d._id, label: d.subDepartmentName }))
              ]}
              noOptionsMessage={() => "No Sub-Departments found"}
              onChange={(selected: any) => {
                if (!selected) return;
                if (selected.value === '__ADD__') { setIsAddingSubDept(true); return; }
                if (selected.value === '__MANAGE__') { setShowSubDeptManager(true); return; }
                setEmployeeDetails({
                  ...employeeDetails,
                  subDepartment: selected.label,
                  subDepartmentRef: selected.value
                });
              }}
              formatOptionLabel={(opt: any) => {
                if (opt.value === '__ADD__') return <span style={{ color: '#0d6efd', fontWeight: 'bold' }}>{opt.label}</span>;
                if (opt.value === '__MANAGE__') return <span style={{ color: '#6c757d' }}>{opt.label}</span>;
                return <span>{opt.label}</span>;
              }}
              styles={{
                control: (base: any) => ({
                  ...base,
                  borderColor: errors.subDepartment ? '#dc3545' : base.borderColor,
                  minHeight: '38px',
                })
              }}
            />
          )}
          <p className="error">{errors.subDepartment}</p>
        </div>

        <div className="col-md-4 mt-3">
          <label className="form-label">{financeCode}</label>
          <span className="required">*</span>
          <input
            type="text"
            value={employeeDetails.financeCode}
            className={`form-control ${errors.financeCode ? 'is-invalid' : ''}`}
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                financeCode: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
          <p className="error">{errors.financeCode}</p>
        </div>

        <div className="col-md-4 mt-3">
          <label className="form-label">{projectClassification}</label>
          <span className="required">*</span>
          <input
            type="text"
            value={employeeDetails.projectClassification}
            className={`form-control ${errors.projectClassification ? 'is-invalid' : ''}`}
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                projectClassification: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
          <p className="error">{errors.projectClassification}</p>
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">{projectType}</label>
          <span className="required">*</span>
          <input
            type="text"
            value={employeeDetails.projectType}
            className={`form-control ${errors.projectType ? 'is-invalid' : ''}`}
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                projectType: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
          <p className="error">{errors.projectType}</p>
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">{location}</label>
          <span className="required">*</span>
          <input
            type="text"
            value={employeeDetails.location}
            className={`form-control ${errors.location ? 'is-invalid' : ''}`}
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                location: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
          <p className="error">{errors.location}</p>
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">{modeofWork}</label>
          <span className="required">*</span>
          <input
            type="text"
            value={employeeDetails.modeofWork}
            className={`form-control ${errors.modeofWork ? 'is-invalid' : ''}`}
            onChange={(e) =>
              setEmployeeDetails({
                ...employeeDetails,
                modeofWork: e.target.value.replace(/^\s+/, ""),
              })
            }
          />
          <p className="error">{errors.modeofWork}</p>
        </div>

        {/* </div> */}
      </div>
      <div className="modal-btn-wrapper mt-5 mx-auto">
        <div>
          <button className="btn cancel-btn buttonsize" onClick={hideAddModal}>
            {cancel}
          </button>
        </div>
        <div>
          <button
            className={
              btnDisable
                ? "btn add-submit-button buttonsize"
                : "btn add-submit-button btn-disabled buttonsize"
            }
            onClick={handleEmployeeSubmit}
            disabled={isSubmitting}
            style={isSubmitting ? { opacity: 0.7, cursor: "not-allowed", display: "flex", alignItems: "center", gap: 6 } : {}}
          >
            {isSubmitting ? <><Spinner size="sm" animation="border" /> Submitting...</> : submit}
          </button>
        </div>
      </div>
      <DepartmentManagerModal
        show={showDeptManager}
        onHide={() => setShowDeptManager(false)}
        title="Departments"
        data={deptOptions.map(d => ({ _id: d._id, name: d.departmentName }))}
        type="DEPARTMENT"
        refreshData={() => dispatch(actions.getAllDepartmentsAction((res: any) => setDeptOptions(res.data)))}
      />

      <DepartmentManagerModal
        show={showSubDeptManager}
        onHide={() => setShowSubDeptManager(false)}
        title="Sub-Departments"
        data={subDeptOptions.map(d => ({ _id: d._id, name: d.subDepartmentName }))}
        type="SUB_DEPARTMENT"
        refreshData={() => {
          // Re-fetch sub-departments for the current selected parent
          const selectedDept = deptOptions.find(d => d.departmentName === employeeDetails.department);
          if (selectedDept) {
            dispatch(actions.getSubDepartmentsByParentAction(selectedDept._id, (res: any) => setSubDeptOptions(res.data)));
          }
        }}
      />
      <ClientManagerModal
        show={showClientManager}
        onHide={() => setShowClientManager(false)}
        data={clientOptions}
        refreshData={() => dispatch(actions.getClientNameAction())}
      />
    </div>
  );
};

export default AddEmployee;
